import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openDataPlatformSubmenu } from '../sidebarHelpers';

const importUserList = (baseUrl, navigate, imports) => {
  return {
    id: 'importUserList',
    title: 'Import your user list / for shopify we sync contacts, import is optional',
    steps: [
      {
        selector: '[data-tour="dataPlatformLink"]',
        content: <p>Click on the "Data Platform" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openDataPlatformSubmenu('[data-tour="profilesLink"]'),
        selector: '[data-tour="profilesLink"]',
        content: <p>Click on the "Profiles" in the navigation.</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/profiles?showAnonymous=false`, true);
        },
        selector: '[data-tour="importProfilesBtn"]',
        content: <p>Click on the "Import Profiles" button.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/profiles?showAnonymous=false&showImportProfilesModal=true`, true),
        selector: '[data-tour="profileImportCsvFormat"]',
        content: <p>You can view the format for the CSV file from this link.</p>,
        stepInteraction: true,
      },
      {
        selector: '[data-tour="uploadFileToImportProfiles"]',
        content: <p>Click on the "Browse" button and choose your CSV file.</p>,
        stepInteraction: true,
      },
      {
        selector: '[data-tour="importProfilesModalBtn"]',
        content: <p>Click on the "Import" button.</p>,
      },
      {
        actionBefore: () => document.querySelector('[data-tour="importProfilesModalBtn"]')?.click(),
        selector: 'body',
        content: <p>You will get a notification in the top right of the window that the import has started.</p>,
        stepInteraction: true,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: imports && imports.length > 0,
  };
};

export default importUserList;
